import { useDispatch, useSelector } from 'react-redux';
import { requestLanguage } from '../../lib/store/language/actions';
export default (function () {
  var language = useSelector(function (state) {
    return state.core.language.language;
  });
  var languageName = useSelector(function (state) {
    return state.core.language.languageName;
  });
  var dispatch = useDispatch();
  return {
    setLanguage: function setLanguage(language) {
      return dispatch(requestLanguage(language));
    },
    language: language,
    languageName: languageName
  };
});